/* Autohobby: Vis flere-paginering på samlingssider. Erstatter sidetall med en knapp som henter
   neste side og legger produktene til i samme grid. Fallback: vanlig paginering hvis noe feiler. */
(function () {
  function init() {
    var pag = document.querySelector('.collection__pagination');
    var list = document.querySelector('.product-list');
    if (!pag || !list || pag.dataset.ahLoadmore) return;
    pag.dataset.ahLoadmore = '1';

    function nextUrl(scope) {
      var link = scope.querySelector('a[rel="next"]') || scope.querySelector('.pagination a[aria-label*="Neste"], .pagination a[aria-label*="Next"]');
      return link ? link.href : null;
    }

    var next = nextUrl(pag);
    if (!next) return; // bare én side

    var totalEl = document.querySelector('.ah-ccount b');
    var total = totalEl ? parseInt(totalEl.textContent.replace(/\\s/g, ''), 10) : null;

    var wrap = document.createElement('div');
    wrap.className = 'ah-loadmore';
    wrap.innerHTML = '<div class="ah-loadmore-progress"><i></i></div><p class="ah-loadmore-count"></p><button type="button" class="ah-loadmore-btn">Vis flere produkter</button>';
    pag.style.display = 'none';
    pag.parentNode.insertBefore(wrap, pag);

    var btn = wrap.querySelector('.ah-loadmore-btn');
    var countEl = wrap.querySelector('.ah-loadmore-count');
    var bar = wrap.querySelector('.ah-loadmore-progress i');

    function shown() { return list.querySelectorAll('product-card').length; }
    function update() {
      var s = shown();
      if (total) {
        countEl.textContent = 'Du har sett ' + s + ' av ' + total + ' produkter';
        bar.style.width = Math.min(100, Math.round(s / total * 100)) + '%';
      } else {
        countEl.textContent = 'Du har sett ' + s + ' produkter';
        bar.style.width = '50%';
      }
    }
    update();

    btn.addEventListener('click', function () {
      if (!next) return;
      btn.disabled = true;
      btn.textContent = 'Henter…';
      fetch(next)
        .then(function (r) { if (!r.ok) throw new Error('http'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newList = doc.querySelector('.product-list');
          if (!newList) throw new Error('parse');
          var cards = newList.children;
          while (cards.length) { list.appendChild(cards[0]); }
          var newPag = doc.querySelector('.collection__pagination');
          next = newPag ? nextUrl(newPag) : null;
          btn.disabled = false;
          btn.textContent = 'Vis flere produkter';
          if (!next) { btn.style.display = 'none'; countEl.textContent = 'Du har sett alle produktene 🎉'; bar.style.width = '100%'; }
          update();
          if (!next && total) { countEl.textContent = 'Du har sett alle ' + total + ' produktene 🎉'; }
        })
        .catch(function () { window.location.href = next; });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();